module.exports = __webpack_public_path__ + "assets/images/announcement-door-window-sensor.png";